import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

import { BASE_URL } from '@/constants/constant';

export const fetchSupplierTypeWiseList = (supplierId, params, merge) => async (dispatch) => {
	try {
		await ApiClient.GET(`${BASE_URL}/supplier/${supplierId}/materials`, params, true).then((response) => {
			dispatch({
				type: Types.FETCH_SUPPLIER_TYPE_WISE_LIST,
				payload: { data: response.data, merge: merge }
			});
		});
	} catch {
		/* Empty Block */
	}
};
